// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"wallet_sectionHeader__ktqWU","buttonRow":"wallet_buttonRow__ZPYxi"};